module.exports = __webpack_public_path__ + "img/Dreitv_wide.82d13df0.jpg";